function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// 0 < percent < 1
export var range = function range(start, end, percent) {
  return (end - start) * percent + start;
};
export var clamp = function clamp(min, max, val) {
  return Math.max(Math.min(val, max), min);
};
export var rangeMap = function rangeMap(arr1, arr2, val) {
  var percent = (val - arr1[0]) / (arr1[1] - arr1[0]);
  return range(arr2[0], arr2[1], percent);
}; // https://twitter.com/chpwn/status/285540192096497664
// iOS constant = 0.55

export var rubberBand = function rubberBand(distance, dimension) {
  var constant = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.15;
  return distance * dimension * constant / (dimension + constant * distance);
};
export var rubberBandIfOutOfBounds = function rubberBandIfOutOfBounds(min, max, delta, constant) {
  if (delta < min) {
    return -rubberBand(min - delta, max - min, constant) + min;
  }

  if (delta > max) {
    return rubberBand(delta - max, max - min, constant) + max;
  }

  return delta;
};
export var decelerationRates = {
  fast: 0.99,
  normal: 0.998
}; // https://medium.com/@nathangitter/building-fluid-interfaces-ios-swift-9732bb934bf5
// note: velocity in UIkit is points per second, but react use gesture gives px per millisecond,
// so we can simplify somewhat

export var projection = function projection(initialVelocity) {
  var rateName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'normal';
  var decelerationRate = typeof rateName === 'number' ? rateName : decelerationRates[rateName];
  return initialVelocity * decelerationRate / (1 - decelerationRate);
};
export var findNearestNumberInArray = function findNearestNumberInArray(n, arr) {
  var sortedArr = _toConsumableArray(arr).sort(function (a, b) {
    return a - b;
  });

  if (n <= sortedArr[0]) return sortedArr[0];
  if (n >= sortedArr[arr.length - 1]) return sortedArr[arr.length - 1];

  for (var i = 1; i < sortedArr.length; i++) {
    var prev = sortedArr[i - 1];
    var current = sortedArr[i];
    if (current === n) return current;

    if (current > n && prev < n) {
      return current - n < n - prev ? current : prev;
    }
  }

  return false;
};